<template>
  <div class="page-content">
    <!-- <div v-if="brandMenu">
    <BrandPage></BrandPage>
  </div> -->
    <div>
      <div class="headings d-flex">
        <h2 v-if="location" class="title title-primary">
          {{ location }}&nbsp;|&nbsp;
        </h2>
        <h2 class="title title-primary">
          {{ $t("lang.dashboard.page_title") }}
        </h2>
      </div>

      <div class="page-header">
        <div class="boxes" v-if="!shouldLoading">
          <bx-box
            v-if="stock.total"
            dark
            color="outline"
            no-padding
            class="col-12 col-md-6 col-lg-auto p-1"
          >
            <bx-complementary
              :total="stock.total"
              :title="$t('lang.dashboard.box_title_1')"
              :left="stock.left"
              :right="stock.right"
            />
          </bx-box>

          <bx-box dark color="outline" class="col-6 col-md-6 col-lg-auto p-1">
            <bx-value
              :label="$t('lang.dashboard.box_title_2')"
              :value="stockDelta"
              units="%"
              font-size="xs"
            />
          </bx-box>

          <bx-box dark color="outline" class="col-6 col-md-6 col-lg-auto p-1">
            <bx-value
              :label="$t('lang.dashboard.box_title_3')"
              :value="precision"
              units="%"
              font-size="xs"
            />
          </bx-box>

          <bx-box dark color="outline" class="col-6 col-md-6 col-lg-auto p-1">
            <bx-value
              :label="$t('lang.dashboard.box_title_4')"
              :value="formatQty(daysInStock)"
              font-size="xs"
            />
          </bx-box>
        </div>
        <skeleton-boxes progress-box :boxes="3" v-else />
      </div>

      <div class="page-main-content">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-xs-12 col-sm-4 no-gutters">
              <bx-box
                :title="$t('lang.dashboard.pie_graph_title_1')"
                color="white"
                :icon="require('@/assets/i/inbound.png')"
                no-padding
              >
                <apexchart
                  v-if="!shouldLoading"
                  ref="chart"
                  type="donut"
                  :options="chart1Options"
                  :series="inboundData"
                ></apexchart>
                <PuSkeleton v-if="shouldLoading" height="250px"></PuSkeleton>
              </bx-box>
            </div>
            <div class="col-xs-12 col-sm-4 no-gutters">
              <bx-box
                :title="$t('lang.dashboard.pie_graph_title_2')"
                color="white"
                :icon="require('@/assets/i/outbound.png')"
                no-padding
              >
                <apexchart
                  v-if="!shouldLoading"
                  ref="chart"
                  type="donut"
                  :options="chart2Options"
                  :series="outboundData"
                ></apexchart>
                <PuSkeleton v-if="shouldLoading" height="250px"></PuSkeleton>
              </bx-box>
            </div>

            <div class="col-xs-12 col-sm-4 no-gutters">
              <bx-box
                :title="$t('lang.dashboard.pie_graph_title_3')"
                color="white"
                :icon="require('@/assets/i/outbound.png')"
                no-padding
              >
                <apexchart
                  v-if="!shouldLoading"
                  ref="chart"
                  type="donut"
                  :options="chart3Options"
                  :series="onlineData"
                ></apexchart>
                <PuSkeleton v-if="shouldLoading" height="250px"></PuSkeleton>
              </bx-box>
            </div>
          </div>

          <bx-box color="white">
            <DynamicChart
              :title="$t('lang.dashboard.line_graph_title')"
              module="graphstatistics"
              :locationId="locationId"
            ></DynamicChart>
          </bx-box>
          <!-- <bx-box color="white">

          <apexchart
            v-if="!shouldLoading"
            type="line"
            height="350"
            :options="multiChartOption"
            :series="multiChartSeries"
          ></apexchart>

        </bx-box> -->
          <!-- <bx-box color="white">
          <v-card
            class="py-5"
            elevation="5"
            height="500"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  dense
                  color="primary"
                  dark
                  class="tool-tip"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-help-circle
                </v-icon>
              </template>
              <span>Multi Info Chart</span>
            </v-tooltip>
            <apexchart
              v-if="!shouldLoading"
              type="line"
              height="350"
              class="mt-10"
              :options="multiChartOption"
              :series="multiChartData.series"
            ></apexchart>
          </v-card>

        </bx-box> -->

          <!-- <div style="height:500px">
          <l-map
            v-if="showMap"
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            @update:zoom="zoomUpdate"
          >
            <l-tile-layer
              :url="url"
              :attribution="attribution"
            />
            <l-marker
              v-for="(marker,index) in markers"
              :key="index"
              :lat-lng="marker">
              <l-popup :content="tooltip" />
              <l-tooltip :content="tooltip" />
            </l-marker>
          </l-map>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import c from "../colors";
import months from "../months";
import DynamicChart from "@/components/DynamicChart";
import common from "@/utils/common";
import chartMixin from "@/utils/chartMixin";
import BrandPage from "@/views/Brand";

// import L from 'leaflet'
// import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from 'vue2-leaflet'
// import { latLng, Icon } from 'leaflet'

// delete Icon.Default.prototype._getIconUrl
// Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// })
let chartOptions = {
  colors: ["#bfdd26", "#FF0000", "#001689"],
  chart: {
    width: 230,
    type: "donut"
  },
  dataLabels: {
    enabled: false,
    style: {
      fontFamily: "Roboto"
    },
    formatter: function(val, opts) {
      return opts.w.config.series[opts.seriesIndex];
    }
  },

  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          name: {
            show: false
          },
          value: {
            show: true,
            fontSize: "16px",
            fontFamily: "Roboto",
            fontWeight: 700,
            color: "#1E1E1E",
            formatter: function(val) {
              return val;
            }
          },
          total: {
            show: true,
            showAlways: true,
            label: "Total",
            fontSize: "22px",
            fontFamily: "Roboto",
            fontWeight: 700,
            color: "#373d3f",
            formatter: function(w) {
              return w.globals.seriesTotals.reduce((a, b) => {
                return parseFloat(parseFloat(a + b).toFixed(3));
              }, 0);
            }
          }
        }
      }
    }
  },
  legend: {
    show: true,
    position: "bottom",
    fontFamily: "Roboto"
  }
};

// let markersArray = [
//   latLng(23.041123, 72.604675),
//   latLng(23.041123, 73.604675),
//   latLng(40.4637, -3.7492),
//   latLng(40.4637, -5.7492),
//   latLng(40.4637, -7.7492)
// ]

let vm = {
  name: "dashboard",
  components: {
    DynamicChart,
    BrandPage
    // LMap,
    // LTileLayer,
    // LMarker,
    // LPopup,
    // LTooltip
  },
  mixins: [common, chartMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      shouldLoading: true,
      daysInStock: "",
      stockDelta: "+12",
      inboundData: {},
      outboundData: {},
      onlineData: {},
      locationId: "",
      evolutionData: {},
      stock: {},
      precision: 0,
      reloadInterval: null,
      chart1Options: {},
      chart2Options: {},
      chart3Options: {}
      // multiChartData: null,
      // multiChartSeries: this.multiChartData.series
      // zoom: 13,
      // center: latLng(40.4637, -3.7492),
      // // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      // url: 'https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=335bf17b022d42fab60a0e0e9a6fa95e',
      // attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      // markers: markersArray,
      // tooltip: 'Hi',
      // mapOptions: {
      //   zoomSnap: 0.5
      // },
      // showMap: true
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    },
    brandMenu: {
      get() {
        return this.$store.getters.brandMenu;
      },
      set(data) {
        this.$store.dispatch("setBrandMenu", data);
      }
    }
  },
  methods: {
    async getStatistics() {
      try {
        if (!this.loading) {
          this.loading = true;
          // this.multiChartData = await this.$api.chart.getMultiGraphData()
          // const companies = await this.$api.company.list()
          let location = localStorage.getItem("location");
          let locationId = localStorage.getItem("location_id");
          if (!location || !locationId) {
            try {
              let firstLocation = await this.$api.location.search("", {
                limit: 1,
                offset: 0,
                orderBy: "id"
              });
              if (firstLocation.count === 0) {
                firstLocation = await this.$api.store.search("", {
                  limit: 1,
                  offset: 0,
                  orderBy: "id"
                });
              }

              localStorage.setItem(
                "location",
                firstLocation.results[0].description
              );
              localStorage.setItem("location_id", firstLocation.results[0].id);

              location = firstLocation.results[0].description;
              locationId = firstLocation.results[0].id;
            } catch (error) {
              console.log(error);
            }
          }
          this.locationId = locationId;

          const statistics = await this.$api.location.statistics(locationId);

          this.daysInStock = statistics.days_of_supply;
          this.stockDelta = statistics.stock_evolution || 0;
          this.stockDelta = this.stockDelta.toFixed(2);

          this.precision =
            statistics.theorical_stock === 0
              ? 0
              : parseInt(
                  (Math.abs(statistics.stock) / statistics.theorical_stock) *
                    100
                );

          this.stock = {
            total: statistics.theorical_stock,
            left: {
              value: statistics.stock,
              label: this.$t("lang.dashboard.box_left_1"),
              icon: require("@/assets/i/boxDark.png")
            },
            right: {
              value: statistics.theorical_stock,
              label:
                statistics.theorical_stock > statistics.stock
                  ? this.$t("lang.dashboard.box_right_option_1")
                  : this.$t("lang.dashboard.box_right_option_2"),
              icon: require("@/assets/i/boxDark.png")
            }
          };

          // Inbound
          this.inboundData = {
            labels: [
              this.$t("lang.dashboard.pie_graph_1_label_1"),
              this.$t("lang.dashboard.pie_graph_1_label_2"),
              this.$t("lang.dashboard.pie_graph_1_label_3")
            ],
            datasets: [
              {
                label: "Data",
                backgroundColor: [c.lime, c.red, c.blue],
                data: [
                  statistics.entrys.correctly_received,
                  statistics.entrys.incorrectly_received,
                  statistics.entrys.waiting
                ]
              }
            ],
            total:
              statistics.entrys.correctly_received +
              statistics.entrys.incorrectly_received +
              statistics.entrys.waiting
          };

          // inbound
          this.chart1Options.labels = [
            this.$t("lang.dashboard.pie_graph_1_label_1"),
            this.$t("lang.dashboard.pie_graph_1_label_2"),
            this.$t("lang.dashboard.pie_graph_1_label_3")
          ];
          this.inboundData = [
            statistics.entrys.correctly_received,
            statistics.entrys.incorrectly_received,
            statistics.entrys.waiting
          ];

          // outbound
          this.chart2Options.labels = [
            this.$t("lang.dashboard.pie_graph_2_label_1"),
            this.$t("lang.dashboard.pie_graph_2_label_2"),
            this.$t("lang.dashboard.pie_graph_2_label_3")
          ];
          this.outboundData = [
            statistics.exits.correctly_exited,
            statistics.exits.incorrectly_exited,
            statistics.exits.waiting
          ];
          // online
          this.chart3Options.labels = [
            this.$t("lang.dashboard.pie_graph_3_label_1"),
            this.$t("lang.dashboard.pie_graph_3_label_2")
          ];
          this.onlineData = [
            statistics.online.sended,
            statistics.online.waiting
          ];

          // Evolution data
          this.evolutionData = {
            labels: months,
            datasets: [
              {
                label: this.$t("lang.dashboard.line_graph_label_1"),
                backgroundColor: c.getRGBA(c.lime, 0.6),
                borderColor: c.lime,
                data: statistics.current_year_stock
              },
              {
                label: this.$t("lang.dashboard.line_graph_label_2"),
                backgroundColor: c.getRGBA(c.blue, 0.6),
                borderColor: c.blue,
                data: statistics.last_year_stock
              }
            ]
          };
          this.loading = false;
          this.shouldLoading = false;
        }
      } catch (error) {
        // console.log(error)
      }
    },
    getRandomColor() {
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += Math.floor(Math.random() * 10);
      }
      return color;
    },
    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + "k"
        : Math.sign(num) * Math.abs(num);
    }
    // zoomUpdate (zoom) {
    //   let mapType = 'transport'
    //   zoom > 10 ? mapType = 'transport' : mapType = 'atlas'
    //   this.url = `https://tile.thunderforest.com/${mapType}/{z}/{x}/{y}.png?apikey=335bf17b022d42fab60a0e0e9a6fa95e`
    //   // 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
    // }
  },
  beforeMount() {
    this.$store.dispatch("setSideMenu", "dashboard_menu");

    this.chart1Options = {
      ...chartOptions,
      responsive: [
        {
          breakpoint: 769,
          options: {
            chart: {
              width: 285
            }
          }
        }
      ]
    };
    this.chart2Options = {
      ...chartOptions,
      responsive: [
        {
          breakpoint: 769,
          options: {
            chart: {
              width: 285
            }
          }
        }
      ]
    };
    this.chart3Options = {
      ...chartOptions,
      colors: ["#bfdd26", "#001689"],
      responsive: [
        {
          breakpoint: 365,
          options: {
            chart: {
              width: 250
            }
          }
        },

        {
          breakpoint: 376,
          options: {
            chart: {
              width: 270
            }
          }
        },

        {
          breakpoint: 468,
          options: {
            chart: {
              width: 300
            }
          }
        },

        {
          breakpoint: 1025,
          options: {
            chart: {
              width: 240
            }
          }
        },

        {
          breakpoint: 1279,
          options: {
            chart: {
              width: 305
            }
          }
        }
      ]
    };
  },
  async mounted() {
    // await this.getMultiData()
    let type = localStorage.getItem("dashboard_type");
    if (!type) {
      localStorage.setItem("dashboard_type", "dashboard");
    }
    this.reloadInterval = setInterval(
      this.getStatistics,
      process.env.VUE_APP_RELOAD_TIME
    );
    this.getStatistics();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};

export default vm;
</script>
